import { IBaseMapper } from '@/bundles/App/interfaces/IBaseMapper';
import { IMarket } from '@/bundles/Markets/interfaces/IMarket';
import { Market } from '@/bundles/Markets/models/Market';

export class MarketToMapper implements IBaseMapper<IMarket> {
  mapToModel (data: IMarket) {
    return new Market(data);
  }
}
